import i18n from './i18n';

export function translateKey(
  key: string,
  options?: Record<string, unknown>,
): string {
  return String(i18n.t(key, options as never));
}
